/** @module @category Breadcrumb */ import { pathToRegexp } from "path-to-regexp";
import { createGlobalStore } from "@openmrs/esm-state";
const store = createGlobalStore('breadcrumbs', []);
function getMatcher(settings) {
    if (settings.matcher instanceof RegExp) {
        return settings.matcher;
    } else if (typeof settings.matcher === 'string') {
        return pathToRegexp(settings.matcher).regexp;
    } else {
        return pathToRegexp(settings.path).regexp;
    }
}
export function registerBreadcrumb(breadcrumb) {
    return registerBreadcrumbs([
        breadcrumb
    ]);
}
export function registerBreadcrumbs(breadcrumbs) {
    const prevBreadcrumbs = getBreadcrumbs();
    const newBreadcrumbs = breadcrumbs.map((settings)=>({
            matcher: getMatcher(settings),
            settings
        }));
    const nextBreadcrumbs = [
        ...prevBreadcrumbs,
        ...newBreadcrumbs
    ];
    store.setState(nextBreadcrumbs, true);
}
export function getBreadcrumbs() {
    return store.getState();
}
